/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Bump_PriorityInputs */

const cs_portals_bump_priority = /** @type {(inputs: Portals_Bump_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priorita`)
};

const en_portals_bump_priority = /** @type {(inputs: Portals_Bump_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priority`)
};

/**
* | output |
* | --- |
* | "Priority" |
*
* @param {Portals_Bump_PriorityInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_bump_priority = /** @type {((inputs?: Portals_Bump_PriorityInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Bump_PriorityInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_bump_priority(inputs)
	return cs_portals_bump_priority(inputs)
});